import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getListKategoriJson } from "stores/Pengajuan/function";

function Step4() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const listJson = pengajuan.getListKategoriJson;
  const isSyariah = valDetail.stepEmpat.kategoriKredit === "syariah";

  // Gabungkan semua produk untuk pencarian label jenis kredit/pembiayaan
  const mergeData = [
    ...(listJson?.jenisKreditKonsumtif || []),
    ...(listJson?.jenisKreditKonsumtifSyariah || []),
    ...(listJson?.jenisKreditProduktif || []),
    ...(listJson?.jenisKreditProduktifSyariah || []),
    ...(listJson?.semuaProduk || []),
  ];

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka || 0);
  };

  const InfoItem = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted fw-bold mb-1 d-block"
        style={{
          fontSize: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </label>
      <div
        className={`p-2 rounded ${isPrimary ? "bg-light border" : ""}`}
        style={{
          fontSize: "14px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
          minHeight: "38px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  React.useEffect(() => {
    if (!listJson) {
      getListKategoriJson(dispatch);
    }
  }, [dispatch, listJson]);

  const getLabel = (category, value) => {
    // Ambil list sesuai kategori dari state Redux
    const categoryList = listJson && listJson[category];

    if (categoryList && Array.isArray(categoryList)) {
      // Cari yang value-nya pas
      const found = categoryList.find(
        (item) => String(item.value) === String(value),
      );
      // Kalau ketemu balikin labelnya, kalau nggak ketemu baru balikin value aslinya
      return found ? found.label : value;
    }

    // Kalau listJson belum keload, balikin value aslinya dulu
    return value || "-";
  };

  return (
    <Row className="mt-3">
      <Col md="12">
        <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
          <Card.Body className="p-4">
            <div
              style={{
                maxHeight: "550px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="custom-scrollbar pr-2"
            >
              <Row>
                {/* --- SEKSI 1: PRODUK & TUJUAN --- */}
                <Col md={12} className="mb-3">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Produk & Tujuan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Kategori Kredit"
                  value={getLabel(
                    "kategoriKredit",
                    valDetail.stepEmpat.kategoriKredit || "konvensional",
                  )}
                  isPrimary
                />
                <InfoItem
                  label={isSyariah ? "Jenis Pembiayaan" : "Jenis Kredit"}
                  value={
                    mergeData.find(
                      (item) =>
                        String(item.value) ===
                        String(valDetail.stepEmpat.jenisKredit),
                    )?.label || valDetail.stepEmpat.jenisKredit
                  }
                  isPrimary
                />
                <InfoItem
                  label="Tujuan Penggunaan"
                  value={
                    valDetail.stepEmpat.tujuanPenggunaan === "1"
                      ? "Konsumtif"
                      : "Produktif"
                  }
                />
                <InfoItem
                  label="Status Pinjaman"
                  value={getLabel(
                    "statusPinjaman",
                    valDetail.stepEmpat.statusPinjaman,
                  )}
                />
                <InfoItem
                  label="Detail Tujuan"
                  value={valDetail.stepEmpat.detailTujuanPenggunaan}
                  col={12}
                />

                {/* --- SEKSI 2: NOMINAL & BUNGA --- */}
                <Col md={12} className="mb-3 mt-4">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Nominal & Suku Bunga
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Nominal Permohonan"
                  value={formatRupiah(valDetail.stepEmpat.nominalPermohonan)}
                  color="#116D6E"
                />
                <InfoItem
                  label="Nominal Pencairan"
                  value={formatRupiah(valDetail.nominalPencairan)}
                  color="#116D6E"
                />
                <InfoItem
                  label="Plafond"
                  value={formatRupiah(valDetail.plafond)}
                  color="#116D6E"
                />
                <InfoItem
                  label="Tenor (Bulan)"
                  value={`${valDetail.stepEmpat.tenor} Bulan`}
                />
                <InfoItem
                  label={isSyariah ? "Margin / Bagi Hasil" : "Suku Bunga"}
                  value={`${valDetail.stepEmpat.sukuBunga}%`}
                  color="#C62D42"
                />
                <InfoItem
                  label="NIP / No. Pegawai"
                  value={valDetail.stepEmpat.nip}
                />

                {/* --- SEKSI 3: DISTRIBUSI & FASILITAS --- */}
                <Col md={12} className="mb-3 mt-4">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Distribusi & Fasilitas
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Cabang Pencairan"
                  value={valDetail.lokasiPencairan?.namaCabang}
                />
                <InfoItem
                  label="Alamat Cabang"
                  value={valDetail.lokasiPencairan?.alamat}
                  col={6}
                />
                <InfoItem
                  label="Pembayaran Gaji Melalui"
                  value={getLabel(
                    "gajiMelalui",
                    valDetail.stepEmpat.pembayaranGajiMelalui,
                  )}
                />
                {valDetail.stepEmpat.tujuanPenggunaan === "1" && (
                  <InfoItem
                    label="Fasilitas"
                    value={getLabel("fasilitas", valDetail.stepEmpat.fasilitas)}
                  />
                )}
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 5px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
        .fw-800 { font-weight: 800; }
      `}</style>
    </Row>
  );
}

export default Step4;
